<p [innerHTML]="referenceDataLabels.AdvisedBuyToLetDescription | localizeLabel" *ngIf="showDescription"></p>

<boi-radio-button-group *ngFor="let question of questions | slice:0:sectionOneEnd" [ngModel]="question.ProvidedAnswer"
    (ngModelChange)="changeQuestionAnswer(question, $event)" [optionList]="referenceDataOptionLists.AnswerType"
    [radioButtonGroupLabel]="question.Value" [tooltipName]="question.Code" [controlId]="question.Code"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>

<boi-drop-down [ngModel]="caseSetup.PropertyLocation" (ngModelChange)="changePropertyLocation($event)"
    [optionList]="referenceDataOptionLists.PropertyLocation"
    [labelName]="referenceDataLabels.EligibilityPropertyTypeQuestion" [isTooltipLast]="false" [cssClasses]="'label-left label-weight-bold label-font-size-13 mb-30'">
</boi-drop-down>

<boi-radio-button-group [labelName]="referenceDataLabels.EligibilityInterestOnlyQuestion"
    [optionList]="referenceDataOptionLists.AnswerType" [ngModel]="interestOnly"
    (ngModelChange)="changeInterestOnly($event)"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>

<boi-radio-button-group [labelName]="referenceDataLabels.EligibilityInterestOnlyValidAssetsQuestion"
    *ngIf="interestOnly === referenceDataOptionLists.AnswerTypeYes" [optionList]="referenceDataOptionLists.AnswerType"
    [ngModel]="interestOnlyValidAssets" (ngModelChange)="changeInterestOnlyValidAssets($event)"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>

<boi-radio-button-group *ngFor="let question of questions | slice:sectionOneEnd" [ngModel]="question.ProvidedAnswer"
    (ngModelChange)="changeQuestionAnswer(question, $event)" [optionList]="referenceDataOptionLists.AnswerType"
    [radioButtonGroupLabel]="question.Value" [tooltipName]="question.Code" [controlId]="question.Code"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>
